export default __webpack_public_path__ + "static/media/goa.1da6202d.jpg";